import React from 'react';
import {
    Button,
    Menu,
    MenuItem,
    Tooltip
} from '@mui/material';
import { DownloadIcon } from '../../../icons';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';


const ExportFile = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            
               <Button display='flex' alignItems='center'
                    sx={{
                        gap: '10px', fontFamily: 'Manrope',
                        background: '#fff',
                        borderRadius: '50px',
                        color: '#64748B',
                        fontSize: '14px',
                        textTransform: 'Uppercase',
                        fontWeight: '500',
                        height: '36px',
                        border: 'none',
                        padding: '8px 16px',
                        border: '1px solid #E5E8EB',
                        '&:hover': {
                            background: '#0076FE',
                            borderColor:'0076FE',
                            color:'#fff'
                        }
                    }}
                    onClick={handleClick}
                    aria-controls={open ? 'download-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <KeyboardTabIcon sx={{ fontSize: '18px', transform: 'rotate(90deg)' }} /> Export
                </Button>
            

            <Menu
                id="download-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'download-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                <MenuItem onClick={handleClose} sx={{ fontSize: '14px', color: '#1A1F36', }}>To PDF</MenuItem>
                <MenuItem onClick={handleClose} sx={{ fontSize: '14px', color: '#1A1F36', }}>To CSV</MenuItem>
            </Menu>
        </div>
    );
}

export default ExportFile;